(() => {
    var window_width = null;
    let dataBodyAttribute = '';
    let announcements = '';

    let tabsHeaderBrandTabs = '';
    let tabsHeaderBrandTabsContainer = '';
    let tabs = '';

    function moveBackgroundToTopLeftMobile() {        
        tabsHeaderBrandTabs = document.getElementsByClassName('header__brands-tab--mobile');
        tabsHeaderBrandTabs[0].style.setProperty('--tabs-overflow', 'hidden');

        let tab1 ='',
            tab2 = '';
        let tab1Rect = '',
            tab2Rect = '';

        getElementsReference().then(({ imageBanner, imageBannerType, bannerRect, tabsHeaderBrandTabs, tabsHeaderBrandTabsContainer, tabs, announcements}) => {

            // ACENTO TAB ---------
            if(dataBodyAttribute == 'decor-living') {
                if(!tabs[0]) {
                    console.error('No se encontró el elemento tabs[1]');
                    return;
                } else {
                    tab1 = tabs[0];
                    tab2 = tabs[1];
                    tab1.style.backgroundRepeat = 'no-repeat';
                    tab1Rect = tab1.getBoundingClientRect();

                    let offsetY_tab1 = null,
                        offsetX_tab1 = null;

                    const tab1Styles = window.getComputedStyle(tab1);
                    const tab1StylesBorder = tab1Styles.getPropertyValue('border-top-width');

                    tab1.style.backgroundSize = `${bannerRect.width}px auto`;

                    offsetX_tab1 = tab1Rect.left * -1; // Desplazamiento horizontal
                    
                    if(announcements.length > 0) {
                        offsetY_tab1 = announcements[0].getBoundingClientRect().height * -1;
                    } else {
                        offsetY_tab1 = (tab1Rect.top - bannerRect.top) * -1;
                    }

                    tab1.style.backgroundPosition = `${offsetX_tab1}px ${offsetY_tab1}px`;
                }
            }
            

            // DECOR TAB ---------
            if(dataBodyAttribute == 'general' || dataBodyAttribute == 'index' || dataBodyAttribute == 'acento') {
                if(!tabs[1]) {
                    console.error('No se encontró el elemento tabs[1]');
                    return;
                } else {
                    tab2 = tabs[1];
                    tab2.style.backgroundRepeat = 'no-repeat';
                    tab2Rect = tab2.getBoundingClientRect();
    
                    let offsetY_tab2 = null,
                        offsetX_tab2 = null;

                    const tab2Styles = window.getComputedStyle(tab2);
                    const tab2StylesBorder = tab2Styles.getPropertyValue('border-top-width');
    
                    if(dataBodyAttribute == 'general' || dataBodyAttribute == 'index' || dataBodyAttribute == 'acento') {
                        tab2.style.backgroundSize = `${bannerRect.width}px auto`;
                        
                        offsetX_tab2 = tab2Rect.left * -1; // Desplazamiento horizontal

                        if(announcements.length > 0) {
                            offsetY_tab2 = (tab2Rect.height - announcements[0].getBoundingClientRect().height) * -1;
                        } else {
                            offsetY_tab2 = (tab2Rect.top - bannerRect.top) * -1;
                        }

                        tab2.style.backgroundPosition = `${offsetX_tab2}px ${offsetY_tab2}px`;
                    }
                }
            }
        });
    }

    function moveBackgroundToTopLeftDesktop() {
        tabsHeaderBrandTabs = document.getElementsByClassName('header__brands-tab--mobile');
        tabsHeaderBrandTabs[0].style.setProperty('--tabs-overflow', 'hidden');

        let tab1 = '',
            tab2 = '';
        let tab1Rect = '',
            tab2Rect = '';

        getElementsReference().then(({ imageBanner, imageBannerType, bannerRect, tabsHeaderBrandTabs, tabsHeaderBrandTabsContainer, tabs, announcements }) => {

            // ACENTO TAB ---------
            if(dataBodyAttribute == 'decor-living') {
                if (!tabs[0]) {
                    console.error('No se encontró el elemento tabs[1]');
                    return;
                } else {
                    tab1 = tabs[0];
                    tab2 = tabs[1];
                    tab1.style.backgroundRepeat = 'no-repeat';
                    tab1Rect = tab1.getBoundingClientRect();

                    let offsetY_tab1 = null,
                        offsetX_tab1 = null;

                    const tab1Styles = window.getComputedStyle(tab1);
                    const tab1StylesBorder = tab1Styles.getPropertyValue('border-top-width');

                    tab1.style.backgroundSize = `${bannerRect.width}px auto`;

                    offsetX_tab1 = tab1Rect.left * -1; // Desplazamiento horizontal

                    if (announcements.length > 0) {
                        offsetY_tab1 = (tab1Rect.height - announcements[0].getBoundingClientRect().height) * -1;
                    } else {
                        offsetY_tab1 = (tab1Rect.top - bannerRect.top) * -1;
                    }

                    tab1.style.backgroundPosition = `${offsetX_tab1}px ${offsetY_tab1}px`;
                }

            }


            // DECOR TAB ---------
            if (dataBodyAttribute == 'general' || dataBodyAttribute == 'index' || dataBodyAttribute == 'acento') {
                if (!tabs[1]) {
                    console.error('No se encontró el elemento tabs[1]');
                    return;
                } else {
                    tab2 = tabs[1];
                    tab2.style.backgroundRepeat = 'no-repeat';
                    tab2Rect = tab2.getBoundingClientRect();

                    let offsetY_tab2 = null,
                        offsetX_tab2 = null;

                    const tab2Styles = window.getComputedStyle(tab2);
                    const tab2StylesBorder = tab2Styles.getPropertyValue('border-top-width');

                    if (dataBodyAttribute == 'general' || dataBodyAttribute == 'index' || dataBodyAttribute == 'acento') {
                        tab2.style.backgroundSize = `${bannerRect.width}px auto`;

                        if (window.scrollY == 0) {
                            // Posiciona el background en la parte superior derecha
                            offsetX_tab2 = tab2Rect.left * -1; // Desplazamiento horizontal
                            offsetY_tab2 = -bannerRect.top; // Desplazamiento vertical
                            tab2.style.backgroundPosition = `${offsetX_tab2}px ${offsetY_tab2}px`;

                        } else {
                            let ulMob = tabsHeaderBrandTabsContainer[0];
                            let ulMobRect = ulMob.getBoundingClientRect();

                            offsetX_tab2 = tab2Rect.left * -1; // Desplazamiento horizontal

                            if (announcements.length > 0) {
                                offsetY_tab2 = announcements[0].getBoundingClientRect().height * -1;
                            } else {
                                offsetY_tab2 = (tab2Rect.top - bannerRect.top) * -1;
                            }

                            tab2.style.backgroundPosition = `${offsetX_tab2}px ${offsetY_tab2}px`;
                        }
                    }
                }
            }
        });
    }
    
    function getElementsReference() {
        let imageBanner = '';
        let imageBannerType = '';
        let bannerRect = '';
        
        return new Promise((resolve, reject) => {
            announcements = document.querySelectorAll('.shopify-section--announcement-bar');
            
            if (window_width < 1150) {
                imageBanner = document.getElementsByClassName('header__wrapper--override-enchliving')[0];
                bannerRect = imageBanner.getBoundingClientRect();

                tabsHeaderBrandTabs = document.getElementsByClassName('header__brands-tab--mobile');
                tabsHeaderBrandTabsContainer = tabsHeaderBrandTabs[0].getElementsByClassName('tabs-container');
                tabs = tabsHeaderBrandTabsContainer[0].getElementsByClassName('tab-item');

                if (!imageBanner) {
                    console.error('No se encontró el elemento <image-banner> mobile');
                    return;
                }

                resolve({imageBanner, imageBannerType, bannerRect, tabsHeaderBrandTabs, tabsHeaderBrandTabsContainer, tabs, announcements});


            } else {
                imageBanner = document.getElementsByClassName('header__wrapper--override-enchliving-inside')[0];
                bannerRect = imageBanner.getBoundingClientRect();

                tabsHeaderBrandTabs = document.getElementsByClassName('header__brands-tab--desk');
                tabsHeaderBrandTabsContainer = tabsHeaderBrandTabs[0].getElementsByClassName('tabs-container-desk');
                tabs = tabsHeaderBrandTabsContainer[0].getElementsByClassName('tab-item');
                imageBannerType = 2;

                resolve({imageBanner, imageBannerType, bannerRect, tabsHeaderBrandTabs, tabsHeaderBrandTabsContainer, tabs, announcements});
            }
        });
    }

    function getTabsView() {
        widthActual().then((width) => {
            if (width < 1150) {
                moveBackgroundToTopLeftMobile();
            } else {
                moveBackgroundToTopLeftDesktop();
            }
        });
    }

    function widthActual() {
        return new Promise((resolve, reject) => {
            window_width = window.innerWidth;
            resolve(window_width);
        });
    }

    document.addEventListener("DOMContentLoaded", (ev) => {
        dataBodyAttribute = document.getElementsByTagName('body')[0].dataset.brand;
        getTabsView();
    });

    window.addEventListener("resize", (event) => {
        getTabsView();
    });
})();